// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_3BXBD","dangerous":"view-default_dangerous_3VYYX"};